import { render } from "./Contabili.vue?vue&type=template&id=37493066&scoped=true"
import script from "./Contabili.vue?vue&type=script&lang=js"
export * from "./Contabili.vue?vue&type=script&lang=js"

import "./Contabili.vue?vue&type=style&index=0&id=37493066&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37493066"]])

export default __exports__